import { BodyText, FlexColumn, HeaderText, Input } from '@make-software/cspr-design';
import styled from 'styled-components';

export const TokenPlateContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    borderRadius: '16px',
    cursor: 'pointer',
    background: theme.styleguideColors.fillSecondary,
    padding: ['16px', '20px 24px'],
  })
);

export const StyledInput = styled(Input)<{ hasError?: boolean }>(({ theme, hasError }) =>
  theme.withMedia({
    height: ['32px', '36px', '40px'],
    div: {
      padding: 0,
      fontSize: ['18px', '24px', '28px'],
      fontWeight: 500,
    },
    input: {
      color: hasError ? theme.styleguideColors.contentRed : theme.styleguideColors.contentPrimary,
    },
  })
);

export const TokenName = styled(HeaderText)(({ theme }) =>
  theme.withMedia({
    fontSize: ['20px', '24px'],
    lineHeight: ['20px', '28px'],
  })
);

export const MaxButton = styled(BodyText)(() => ({
  cursor: 'pointer',
}));

export const FiatRateText = styled(BodyText)(() => ({
  marginRight: 'auto',
}));
